/**
 * Form handling
 */
import ui from '../ui';

require('form-serializer/dist/jquery.serialize-object.min');

/**
 * Initialize a container for form handling
 * @param {jQuery} $container
 */
const initializeContainer = function($container) {
    $container.find('form').submit(function() {
        return submit($(this));
    });
};

/**
 * Start loading
 * @param $container
 */
const startLoading = function($container) {
    let $overlay = $container.closest('[data-loading-overlay]');
    if ($overlay.length > 0) {
        $container.find(':focus').blur();
        $overlay.addClass('loading-overlay-showing');
    }
};

/**
 * Stop loading
 * @param $container
 */
const stopLoading = function($container) {
    let $overlay = $container.closest('[data-loading-overlay]');
    if ($overlay.length > 0) {
        $overlay.removeClass('loading-overlay-showing');
    }
};

/**
 * Submit a form
 * @param {jQuery} $form
 */
const submit = function($form) {
    startLoading($form);

    // Filter all inputs by disabling them if their
    // value is empty
    if ($form.attr('data-filter') !== undefined) {
        $form.find('[name]').each(function() {
            if ($(this).val().length === 0) {
                $(this).prop('disabled', true);
            }
        });
    }

    // Disable any summernote inputs
    let $summerNoteInstances = $form.find('[data-plugin-summernote]');
    if ($summerNoteInstances.length > 0) {
        let $summerNoteContainer = $summerNoteInstances.next('.note-editor');
        // Ensure code view is exited as only then the HTML is set in the textarea
        $summerNoteContainer.find('.btn-codeview.active').click();
        $summerNoteContainer.find('input').prop('disabled', true);
    }

    if ($form.data('result')) {
        let $resultContainer = $($form.data('result'));
        if ($resultContainer.length === 1) {
            submitWithAjax($form, $resultContainer);
            return false;
        }
    }
};

/**
 * Submit a form with AJAX
 * @param {jQuery} $form
 * @param {jQuery} $resultContainer
 */
const submitWithAjax = function($form, $resultContainer) {
    let options    = $form.data('ajax-options') || {};
    options.method = options.method || $form.prop('method') || 'POST';
    options.url    = options.url || $form.attr('action');

    options.data = $form.serializeObject();

    options.complete = function(data) {
        let $newForm = $(data.responseText);
        $resultContainer.empty().append($newForm);
        ui.initializeContainer($resultContainer);
        stopLoading($newForm);
    };

    $.ajax(options);
};

export default {
    initializeContainer: initializeContainer,
    submit:              submit,
    submitWithAjax:      submitWithAjax,
    startLoading:        startLoading,
    stopLoading:         stopLoading,
};


// WEBPACK FOOTER //
// ./plugins/Admin/build/script/src/components/forms.js